<template>
  <div>
    <div style="display:flex;gap:10px;">
      <div style="width:100%;">
        <div class="toolbar">
          <div class="toolbar-left">
            <div class="toolbar__row toolbar__row--between">
              <div class="toolbar__column">
                <div
                  class="search-filter"
                >
                  <b-icon-search />
                  <input
                    v-model="searchValue"
                    type="text"
                    autocomplete="off"
                    name="search-box"
                    :placeholder="$t(toggleSearch)"
                    @keydown.down.prevent="arrowDown"
                    @keydown.up.prevent="arrowUp"
                    @keydown.enter.prevent="selectHighlighted"
                  >
                  <b-icon-x-circle
                    class="search-filter__clear"
                    :class="{ 'search-filter__clear--active': searchValue !== '' }"
                    @click="searchValue = ''"
                  />
                  <b-form-select
                    v-model="toggleSearch"
                    :options="searchFilterOptions"
                  />
                  <LoadingWrapperSpinner
                    ref="scrollContainer"
                    class="search-filter__options"
                  >
                    <div
                      v-for="(result, index) in filteredResults"
                      :key="index"
                      ref="options"
                      :class="{ 'is-active': index === arrowCounter }"
                      class="search-filter__option"
                      @click="selectResult(result)"
                    >
                      {{ displayResult(result) }}
                    </div>
                  </LoadingWrapperSpinner>
                </div>
              </div>
              <div />
            </div>
            <div class="toolbar__row toolbar__row--between mt-4">
              <div class="toolbar__column">
                <label class="mr-2">{{ $t('SelectStore') }}</label>
                <StoresDropdown
                  :filiale="filiale"
                  :all-included="'All'"
                  @updateFiliale="updateFiliale"
                />
              </div>
              <div class="toolbar__column">
                <label class="mr-2">{{ $t('SelectState') }}</label>
                <b-form-group>
                  <vue-select
                    v-model="selectedOrderState"
                    class="custom-selected-input"
                    label="text"
                    :reduce="(e) => e.value"
                    :placeholder="$t('SelectState')"
                    :options="stateOptionsFiltered"
                  />
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 100%; margin-top: -1px;">
          <table
            class="team_table"
          >
            <thead>
              <tr>
                <th>
                  {{ $t('OrderID') }}
                </th>
                <th>
                  {{ $t('OrderType') }}
                </th>
                <th>
                  {{ $t('StoreName') }}
                </th>
                <th>
                  {{ $t('CustomerName') }}
                </th>
                <th>
                  {{ $t('Created') }}
                </th>
              </tr>
            </thead>
            <LoadingSpinnerTable
              :is-loading="isRequestLoading('loadMinimalOrderDetailsByState')"
              :cols="22"
              :response-data="getMinimaldOrderDetailss"
            >
              <tr
                v-for="order in pagedOrders"
                :key="order.orderId"
                v-b-tooltip.hover
                :title="$t('Click')"
                class="hover-row"
                style="cursor: pointer;"
                :style="clickedOrder === order.orderNumber ? 'background-color: rgba(255, 39, 79, 0.1)' : ''"
                @click="showOrderItems(order)"
              >
                <td>
                  {{ order.orderNumber }}
                </td>
                <td>
                  {{ order.orderType }}
                </td>
                <td>
                  {{ order.storeName }}
                </td>
                <td>
                  {{ order.customerName }}
                </td>
                <td>
                  {{ formatDate(order.created) }}
                </td>
              </tr>
            </LoadingSpinnerTable>
          </table>
          <div>
            <b-pagination
              v-if="totalItems > pageSize"
              v-model="page"
              :total-rows="totalItems"
              :per-page="pageSize"
              first-number
              last-number
              align="fill"
              size="md"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
            >
              <template #prev-text>
                <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
              </template>
              <template #next-text>
                <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
              </template>
            </b-pagination>
          </div>
        </div>
      </div>
      <div style="width:100%;">
        <div
          class="toolbar"
          style="height:62px;"
        />
        <div style="width: 100%;">
          <table class="team_table">
            <thead>
              <tr>
                <th>
                  {{ $t("houseName") }}
                </th>
                <th>
                  {{ $t("floorName") }}
                </th>
                <th>
                  {{ $t("roomName") }}
                </th>
                <th>
                  {{ $t("objectName") }}
                </th>
                <th>
                  {{ $t('Add') }}
                </th>
              </tr>
            </thead>
            <LoadingSpinnerTable
              :is-loading="isRequestLoading('orderDetailsOrderId')"
              :response-data="formattedOrderDetails"
              :cols="10"
            >
              <tr
                v-for="(item, index) in formattedOrderDetails"
                :key="index"
              >
                <td>
                  {{ item.houseName }}
                </td>
                <td>
                  {{ item.floorName }}
                </td>
                <td>
                  {{ item.roomName }}
                </td>
                <td>
                  {{ item.objectName }}
                </td>
                <td>
                  <button
                    v-b-modal.is-order-pending-modal
                    class="primary"
                    @click="isOrder(item)"
                  >
                    {{ $t('Add') }}
                  </button>
                </td>
              </tr>
            </LoadingSpinnerTable>
          </table>
        </div>
        <IsOrderPendingModal
          :clicked-order="clickedOrder"
          :clicked-order-item-id="clickedOrderItemId"
          :clicked-house-all="clickedHouseAll"
          :store-id="clickedStoreId"
          @updateOrderItemPending="updateOrderItemPendings"
        />
      </div>
    </div>

  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import 'jspdf-autotable';
import StoresDropdown from '../StoresDropdown.vue';
import IsOrderPendingModal from './modals/IsOrderItemPending.vue';

export default {
  components: {
    StoresDropdown,
    IsOrderPendingModal,
  },
  props: [],
  data() {
    return {
      skipWatch: false,
      toggleSearch: 'OrderNumber',
      searchFilterOptions: [
        { text: this.$t('CustomerName'), value: 'CustomerName' },
        { text: this.$t('OrderNumber'), value: 'OrderNumber' },
      ],
      filiale: { storeId: null, storeName: 'All', storeGLN: null },
      searchOrder: '',
      clientId: null,
      searchCN: '',
      page: 1,
      pageSize: 15,
      arrowCounter: 0,
      enterPressed: false,
      clickedOrder: null,
      clickedOrderItemId: null,
      clickedHouseAll: null,
      clickedOrderId: null,
      clickedStoreId: null,
      selectedOrderState: 'InPacking',
    }
  },
  computed: {
    ...mapGetters([
      'getMinimaldOrderDetailss',
      'getTotalItemsForOrderN',
      'getTotalMinimalItemsForOrderDetails',
      'getSearchInNewOrders',
      'getFirstNames',
      'getOrderDetailsByOrderId',
      'getOrderItemStates',
    ]),
    filteredOrders() {
      let filtered = this.getMinimaldOrderDetailss || [];

      const isValidStoreId = (
        this.filiale.storeId
        && this.filiale.storeId !== '00000000-0000-0000-0000-000000000000'
        && this.filiale.storeId.toLowerCase() !== 'all'
      );
      // Filter by store if set
      if (isValidStoreId) {
        filtered = filtered.filter((order) => { return (order.storeId || '').toLowerCase() === (this.filiale.storeId || '').toLowerCase() });
      }
      // Filter by search input if any
      const searchTerm = (this.searchValue || '').toLowerCase();
      if (searchTerm) {
        if (this.toggleSearch === 'OrderNumber') {
          filtered = filtered.filter((order) => { return (order.orderNumber || '').toLowerCase().includes(searchTerm) });
        } else if (this.toggleSearch === 'CustomerName') {
          filtered = filtered.filter((order) => { return (order.customerName || '').toLowerCase().includes(searchTerm) });
        }
      }
      return filtered;
    },
    totalItems() {
      return this.filteredOrders.length;
    },
    totalPages() {
      return Math.ceil(this.totalItems / this.pageSize);
    },
    pagedOrders() {
      const startIndex = (this.page - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.filteredOrders.slice(startIndex, endIndex);
    },
    formattedOrderDetails() {
      return this.getOrderDetailsByOrderId.map((detail) => {
        const parts = detail.articleName.split('/');

        return {
          windowId: detail.windowId,
          houseName: parts[0] || 'Shtepia',
          floorName: parts[1] || 'Kati',
          roomName: parts[2] || 'Dhoma',
          objectName: parts[3] || 'Objekti(Dritare/Tepison)',
        };
      });
    },
    searchValue: {
      get() {
        if (this.toggleSearch === 'OrderNumber') return this.searchOrder;
        if (this.toggleSearch === 'CustomerName') return this.searchCN;
        return '';
      },
      set(value) {
        if (this.toggleSearch === 'OrderNumber') this.searchOrder = value;
        else if (this.toggleSearch === 'CustomerName') this.searchCN = value;
      },
    },
    filteredResults() {
      if (this.toggleSearch === 'OrderNumber') return this.getSearchInNewOrders;
      if (this.toggleSearch === 'CustomerName') return this.getFirstNames;
      return [];
    },
    stateOptionsFiltered() {
      const uniqueOrderItemStates = this.getOrderItemStates;
      console.log('uniqueOrderItemStates', uniqueOrderItemStates);

      // Define states to Include
      const statesToInclude = ['Assigned', 'Confirmed', 'InPattern', 'InPatternQualityPassed', 'InPatternQualityNotPassed', 'InPatternCompleted', 'InSewingAssigned', 'InSewingConfirmed', 'InSewing', 'InSewingQualityPassed', 'InSewingQualityNotPassed', 'InSewingCompleted', 'InPackingAssigned', 'InPackingConfirmed', 'InPacking'];

      // Filter out the states you want to include
      const filteredStates = uniqueOrderItemStates.filter((state) => { return statesToInclude.includes(state) });

      const options = filteredStates.map((state) => {
        return {
          value: state,
          text: this.$t(state),
        }
      });

      return options
    },
  },
  watch: {
    selectedOrderState(newValue) {
      if (newValue) {
        this.loadMinimalOrderDetailsByState({
          pageNumber: this.page,
          pageSize: this.pageSize,
          orderNumber: this.searchOrder || null,
          clientId: this.clientId || null,
          storeId: this.filiale.storeId,
          state: newValue, // Pass the selected state
        });
      }
    },
  },
  mounted() {
    // Call orderItemStates to fetch the states
    this.orderItemStates();
  },
  methods: {
    ...mapActions([
      'resetFirstNames',
      'loadMinimalOrderDetailsByState',
      'resetSearchInNewOrders',
      'searchInNewOrders',
      'firstNames',
      'loadIsOrderInTransit',
      'orderDetailsOrderId',
      'resetMinimalOrderDetailsByState',
      'orderItemStates',
    ]),
    updateOrderItemPendings() {
      this.orderDetailsOrderId({
        orderId: this.clickedOrderId,
      })
    },
    showOrderItems(order) {
      this.orderDetailsOrderId({
        orderId: order.orderId,
      })
      this.clickedOrder = order.orderNumber
      this.clickedOrderId = order.orderId
      this.clickedStoreId = order.storeId
    },
    isOrder(value) {
      this.loadIsOrderInTransit({
        orderItemId: value?.windowId,
        storeId: this.clickedStoreId,
      })
      this.clickedOrderItemId = value.windowId
      this.clickedHouseAll = `${value.houseName}/${value.floorName}/${value.roomName}/${value.objectName}`
    },
    displayResult(result) {
      if (this.toggleSearch === 'CustomerName') return result.nameToDisplay;
      return result;
    },
    selectResult(result) {
      if (this.toggleSearch === 'OrderNumber') this.searchByOn(result);
      else if (this.toggleSearch === 'CustomerName') this.searchByCn(result);
    },
    arrowDown(ev) {
      ev.preventDefault()
      if (this.arrowCounter < this.filteredResults.length - 1) {
        this.arrowCounter++;
        this.fixScrolling();
      }
    },
    arrowUp(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter--;
        this.fixScrolling();
      }
    },
    selectHighlighted() {
      if (this.arrowCounter >= 0 && this.filteredResults.length > 0) {
        this.selectResult(this.filteredResults[this.arrowCounter]);
      }
    },
    fixScrolling() {
      this.$nextTick(() => {
        const options = this.$refs.options;
        const scrollContainer = this.$refs.scrollContainer?.$el;

        if (!options || !options[this.arrowCounter] || !scrollContainer) return;
        const selectedOption = options[this.arrowCounter];
        const optionHeight = selectedOption.clientHeight;

        const containerRect = scrollContainer.getBoundingClientRect();
        const selectedRect = selectedOption.getBoundingClientRect();

        if (selectedRect.bottom > containerRect.bottom) {
          scrollContainer.scrollTop += optionHeight;
        } else if (selectedRect.top < containerRect.top) {
          scrollContainer.scrollTop -= optionHeight;
        }
      });
    },
    updateFiliale(newFiliale) {
      this.filiale = newFiliale;
      this.loadMinimalOrderDetailsByState({
        pageNumber: this.page,
        pageSize: this.pageSize,
        orderNumber: this.searchOrder || null,
        clientId: this.clientId || null,
        storeId: newFiliale.storeId,
        state: this.selectedOrderState,
      });
    },
    formatDate(value) {
      let date
      if (value) {
        date = moment(value).format('YYYY-MM-DD')
      } else {
        date = 'No Date'
      }
      return date
    },
    async searchByOn(value) {
      this.skipWatch = true;
      this.removeLists()
      this.searchOrder = value
      await this.loadMinimalOrderDetailsByState({
        pageNumber: this.page,
        pageSize: this.pageSize,
        orderNumber: this.searchOrder,
        storeId: this.filiale.storeId,
        state: this.selectedOrderState,
      })
    },
    async searchByCn(value) {
      this.skipWatch = true;
      this.removeLists()
      this.searchCN = value.nameToDisplay
      this.clientId = value.clientId
      await this.loadMinimalOrderDetailsByState({
        pageNumber: this.page,
        pageSize: this.pageSize,
        orderNumber: null,
        clientId: value.clientId,
        storeId: this.filiale.storeId,
        state: this.selectedOrderState,
      })
    },
    removeLists() {
      this.resetFirstNames()
      this.resetSearchInNewOrders();
    },
    inputChanged1(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') { return; }
      // this.getSearchInNewOrders = [];

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true
        this.searchByCn(this.getFirstNames[this.arrowCounter])
        this.removeLists()
        this.arrowCounter = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    inputChanged(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') { return; }
      // this.getFilteredActiveUsers = [];

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true
        this.searchByOn(this.getSearchInNewOrders[this.arrowCounter])
        this.removeLists()
        this.arrowCounter = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
  },
}
</script>

<style scoped lang="scss">
.hover-row:hover {
    background-color: rgba(255, 39, 79, 0.1);
}
</style>
